import dj from "dayjs"
import { Message, MessageBox } from "element-ui"
import { markRead } from "@/api/userCenter/message"
import router from "@/router"
import { retryServiceTaskSync } from "@/api/workflow/workflow"

export const messageTypeMap = {
  COMMON: "通知",
  VERIFY: "审核",
  IMPORT: "导入",
  EXPORT: "导出",
  SYSTEM: "系统",
  TASK: "任务",
  COMPANY: "企业",
  COMPANY_CONNECT: "企业互联",
  WORKFLOW: "工作流",
  DISCUSSION: "讨论"
}

export const readTypeMap = {
  all: "全部消息",
  read: "已读消息",
  unread: "未读消息",
  sync: "同步记录"
}

export const pickerOptions = {
  shortcuts: [
    {
      text: "最近24小时",
      onClick(picker) {
        picker.$emit("pick", [
          dj()
            .subtract(1, "day")
            .toDate(),
          new Date()
        ])
      }
    },
    {
      text: "最近一周",
      onClick(picker) {
        picker.$emit("pick", [
          dj()
            .subtract(7, "day")
            .toDate(),
          new Date()
        ])
      }
    },
    {
      text: "最近一个月",
      onClick(picker) {
        picker.$emit("pick", [
          dj()
            .subtract(1, "month")
            .toDate(),
          new Date()
        ])
      }
    },
    {
      text: "最近三个月",
      onClick(picker) {
        picker.$emit("pick", [
          dj()
            .subtract(3, "month")
            .toDate(),
          new Date()
        ])
      }
    }
  ]
}

export function dealMessage(message, download = false) {
  let { type, extra, date } = message
  switch (type) {
    case "COMMON":
    case "TASK":
      break
    case "VERIFY":
      // eslint-disable-next-line no-case-declarations
      let { sheetDataId, appId } = extra
      router.goto({ name: "company-todo" })
      break

    case "DATA":
      router.goto({ name: "system-message" })
      break
    case "IMPORT":
    case "EXPORT":
      if (download === true) {
        // eslint-disable-next-line no-case-declarations
        let fileExpired =
          date &&
          dj(date)
            .add(7, "day")
            .isBefore(new Date())
        if (!fileExpired) {
          if (typeof extra != "string") extra = extra.url
          ;/https:\/\/new-service/.test(extra) && window.open(extra)
        } else Message.warning("此文件已过期")
      }
      break
    case "SYSTEM":
      window.open("https://www.yuque.com/service2/manual/version")
      break
    case "COMPANY_CONNECT":
      if (extra) {
        MessageBox.confirm("是否重试?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          retryServiceTaskSync(extra).then(() => Message.success("操作成功"))
        })
      }
      break
  }
  return markRead(message?.id)
}

export const logTableColumns = [
  {
    label: "规则名称",
    value: "ruleName",
    width: "150px",
    align: "center"
  },
  {
    label: "同步路径",
    value: "syncPath",
    width: "200px"
  },
  {
    label: "状态",
    value: "status",
    width: "60px",
    align: "center"
  },
  {
    label: "同步总数(条)",
    value: "total",
    width: "100px",
    align: "center"
  },
  {
    label: "同步未执行数(条)",
    value: "leftCount",
    width: "140px",
    align: "center"
  },
  {
    label: "失败数据",
    value: "dataTitle",
    width: "150px",
    align: "center"
  },
  {
    label: "失败原因",
    value: "failRes",
    width: "150px",
    align: "center"
  },
  {
    label: "流程触发人",
    value: "creator.name",
    width: "150px",
    align: "center"
  },
  {
    label: "同步开始时间",
    value: "startAt",
    width: "156px",
    align: "center"
  },
  {
    label: "同步完成时间",
    value: "endAt",
    width: "156px",
    align: "center"
  }
]

export const logoTypeMap = {
  VERIFY: {
    svg: "message_verify",
    color: "icon-verify",
    name: "审批"
  },
  TASK: {
    svg: "message_task",
    color: "icon-task",
    name: "任务"
  },
  IMPORT: {
    svg: "message_import",
    color: "icon-import",
    name: "导入"
  },
  EXPORT: {
    svg: "message_export",
    color: "icon-export",
    name: "导出"
  },
  COMPANY_CONNECT: {
    svg: "message_connect",
    color: "icon-company",
    name: "企业互联"
  },
  COMPANY: {
    svg: "message_company",
    color: "icon-company",
    name: "企业"
  },
  SYSTEM: {
    svg: "message_system",
    color: "icon-system",
    name: "系统消息"
  },
  COMMON: {
    svg: "message_data",
    color: "icon-data",
    name: "通知"
  },
  WORKFLOW: {
    svg: "message_workflow",
    color: "icon-verify",
    name: "工作流"
  },
  NULL: {
    svg: "",
    color: "",
    name: ""
  },
  DISCUSSION: {
    svg: "message_discuss",
    color: "icon-discuss",
    name: "讨论"
  }
}

export const fileTypeMap = {
  xlsx: "xlsx",
  pdf: "pdf",
  docx: "word",
  doc: "word",
  zip: "zip",
  pptx: "pptx",
  key: "pptx"
}

export const fileIconMap = {
  xlsx: "message_excel",
  pdf: "message_pdf",
  word: "message_word",
  zip: "message_zip",
  pptx: "message_pptx",
  file: "message_file"
}
